import { MenuItem } from 'primeng/api';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';
import { updateResultValue } from '@core/_utils/tools.utils';
import { lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'app-add-results',
    templateUrl: './add-results.component.html',
    styleUrls: ['./add-results.component.scss'],
})
export class AddResultsComponent implements OnInit {
    public errorMessage = '';
    public errorLoaderDialog = false;

    @Input()
    public indexList = [];
    @Input()
    public systemList = [];
    @Input()
    public propertiesList = [];
    @Input()
    public propBskList = [];

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    public items: Array<MenuItem>;

    constructor(
        private translate: TranslateService,
        private api: ApiV6Service,
        protected _messageService: MessagesService) {
        }

    ngOnInit() {
    }

    public async validate(result) {
        let wRes: any = {};
        // id de la requête forcé à 0 : création
        result.entete.id = 0;
        const wParams = updateResultValue(result.entete, result.detail);
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('updateresult', wParams ));
            wRes.data.entete.description = wRes.data.entete.desc;
            delete wRes.data.entete.desc;
            this.onValidate.emit({ data: wRes.data, duplicate: false });            
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
    }

    cancel() {
        this.onCancel.emit({ id: null });
    }
}
